import { ApiResponse } from "@/utils/ApiResponse";
import { CategoriasProductoInterface } from "../../interfaces/categoriaInterfaces/CategoriasProducto.interface";
import apiClient from "@/clients/apiClient";

export async function DeleteCategoriaProductoAction (
    categoriaId: string
): Promise<ApiResponse<CategoriasProductoInterface>> {
   const {data} = await apiClient.delete(`gpCategoriasProducto/${categoriaId}`);
    return {
        status: 200,
        data,
        message: "Categoría de producto eliminada correctamente",
    };
}
    